import { render, staticRenderFns } from "./instituciones.vue?vue&type=template&id=7ccf1fbc&"
import script from "./instituciones.vue?vue&type=script&lang=js&"
export * from "./instituciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports